/* eslint-disable @typescript-eslint/no-unused-vars */
import {ViewProps} from './model';
import {GetStyles} from './styles';
import {StyleSheet, View} from 'react-native';
import React from 'react';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {Text} from '../../../../shared/components/text';
import {TransportCardPaymentHistoryItem} from '../../../../shared/models/api/transportCardPaymentHistory';
import {format} from 'date-fns';
import {dateFormats} from '../../../../shared/constants/date';

export const DesktopView = ({list}: ViewProps) => {
  const styles = GetStyles();

  const columns: Column<TransportCardPaymentHistoryItem>[] = [
    {
      title: 'Наименование пополнения',
      render: (item) => <Text type='h6Light'>{item.payment.description}</Text>,
      field: 'description',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colDescription)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colDescription)},
      },
    },
    {
      title: 'Сумма, ₽',
      render: (item) => <Text type='h6Light'>{item.amountInRubles}</Text>,
      field: 'amount',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colAmount)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colAmount)},
      },
    },
    {
      title: 'Дата',
      render: (item) => <Text type='h6Light'>{format(new Date(item.date), dateFormats.fullDate)}</Text>,
      field: 'date',
      headStyles: {
        colHeadStyle: {...StyleSheet.flatten(styles.headCell), ...StyleSheet.flatten(styles.colDate)},
      },
      styles: {
        colBodyStyle: {...StyleSheet.flatten(styles.cell), ...StyleSheet.flatten(styles.colDate)},
      },
    },
  ];

  return (
    <View style={styles.container}>
      {!list || !list.length ? (
        <Text style={styles.noData}>Нет данных</Text>
      ) : (
        <Table data={list} columns={columns} testIdPrefix='history-table' />
      )}
    </View>
  );
};
